import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { VehicleModelService } from '../../crud-vehicle-module-cars/services/vehicle-model.service';
import { Vehicle } from '../../crud-vehicle-module-cars/vehicle';
import { OdsHistory } from './ods-history.interface';
@Component({
  selector: 'app-ods',
  templateUrl: './ods.component.html',
  styleUrl: './ods.component.css',
})
export class OdsComponent implements OnChanges {
  @Input() selectedVehicle!: Vehicle;

  isDarkMode = false;
  store: any;
  selectedAvatar: string | null = null;
  odsHistory: OdsHistory[] = [];

  constructor(
    private router: Router,
    private storeData: Store<any>,
    private analitycs: AnalitycsService,
    private vehicleModelService: VehicleModelService,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }
  ngOnInit() {
    this.analitycs.logEvent('el_usuario_ingresa_a_ods', {
      pantalla: 'ods',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.selectedAvatar = localStorage.getItem('selectedAvatar') ?? 'assets/images/juan2.png';
    // const storedAvatar = localStorage.getItem('selectedAvatar'); // Obtiene el avatar guardado
    // if (storedAvatar) {
    //   this.selectedAvatar = storedAvatar; // Si existe, se lo asignamos
    // } else {
    //   this.selectedAvatar = 'assets/images/juan1.png'; // Opción predeterminada (Juan)
    // }
  }

  goToEditProfile() {
    this.analitycs.logEvent('ir_a_editar_perfil_desde_ods', {
      pantalla: 'ods',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/edit-profile']);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedVehicle']) {
      this.loadOdsHistory();
    }
  }
  async loadOdsHistory() {
    try {
      //   this.loading = true;
      this.odsHistory = await this.vehicleModelService.getOdsHistory(this.selectedVehicle.plate ?? '');
    } catch (error) {
      console.error('Error al cargar el historial de ODS:', error);
      //   this.error = 'No se pudo cargar el historial ODS. Por favor intente nuevamente.';
    } finally {
      //   this.loading = false;
    }
  }
  openExternalLink(id: string) {
    this.analitycs.logEvent('el_usuario_abre_link_de_ods', {
      pantalla: 'ods',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    const url = `https://tuulapp.com/3/?i=${id}`;
    window.open(url, '_blank');
  }
}
